
import FilterIcon from '@/components/Icons/FilterIcon.vue'
import AddIcon from '@/components/Icons/AddIcon.vue'
import TickIcon from '@/components/Icons/TickIcon.vue'
import { computed, defineComponent, onMounted, PropType, reactive, ref, toRefs } from 'vue'
import CloseIcon from '@/components/Icons/CloseIcon.vue'
import PenIcon from '@/components/Icons/PenIcon.vue'
import DButton from '@/components/base/DButton.vue'
import { useQuasar } from 'quasar'

interface FilterValue {
  val: string;
  label: string;
}

export default defineComponent({
  name: 'FilterableList',
  components: { PenIcon, CloseIcon, TickIcon, AddIcon, FilterIcon, DButton },
  emits: ['update:searchValue', 'update:filterValue', 'cancel', 'save', 'add'],

  props: {
    searchValue: {
      type: String,
      default: '',
    },
    filterValues: {
      type: Array as PropType<FilterValue[]>
    },
    filterValue: {
      type: String,
      default: 'everything'
    },
    editing: {
      type: Boolean,
      default: false,
    },
    height: {
      type: Number,
    },
    expanded: {
      type: Boolean
    },
    readonly: {
      type: Boolean
    }
  },

  setup (props, { emit }) {
    const $q = useQuasar()

    const parentEl = ref<HTMLElement>()
    const fixedElement = ref<HTMLElement>()

    function emitSearchQuery ($event) {
      emit('update:searchValue', $event)
    }

    function emitFilter ($event) {
      emit('update:filterValue', $event)
    }

    onMounted(() => {
      // get element position from top and width of parent element
      // const position = (fixedElement.value as HTMLElement).getBoundingClientRect().top + window.scrollY
      // const width: number = (parentEl.value as HTMLElement).clientWidth

      // window.addEventListener('scroll', function (e) {
      //   if (!fixedElement.value) return
      //   const isPositionFixed = fixedElement.value ? window.getComputedStyle(fixedElement.value).position === 'fixed' : false

      //   // position - 8 to adjust fixed position with top property
      //   // set width from parent, so it doesn't take full width of the viewport
      //   if (window.scrollY > (position - 8) && !isPositionFixed) {
      //     fixedElement.value.style.position = 'fixed'
      //     fixedElement.value.style.top = '0'
      //     fixedElement.value.style.width = `${width}px`
      //   }

      //   if (window.scrollY < (position - 8) && isPositionFixed) {
      //     fixedElement.value.style.position = 'static'
      //     fixedElement.value.style.top = '.5rem'
      //     fixedElement.value.style.width = '100%'
      //   }
      // })
    })

    const list = ref<HTMLDivElement | null>(null)

    return {
      isMobile: computed(() => $q.screen.lt.sm),
      emitSearchQuery,
      emitFilter,
      fixedElement,
      parentEl,
      list
    }
  }
})
